var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-switch"},[_c('label',{staticClass:"x-label",staticStyle:{"margin-right":"8px"}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('el-switch',{attrs:{"value":_vm.value,"active-text":_vm.activeText,"inactive-text":_vm.inactiveText,"disabled":_vm.disable},on:{"input":function($event){return _vm.handleInput($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }